import React, {Component} from "react";
import PropTypes from "prop-types";
import moment from 'moment';
import {I18n} from 'react-redux-i18n';
import { SORT_DIRECTION } from '@common/constants';
import { Table, HIGHLIGHT_BACKGROUND_COLOR } from '@common/components/Table';

import '../styles/UsersTable.scss'

export default class UsersTable extends Component {
    constructor(props) {
        super(props);
        
        this.columns = [];
        this.rowHeight = 30;
        this.headerHeight = 30;
        this.state = {
            height: 200,
            sortField: 'username',
            sortDirection: SORT_DIRECTION.asc,
        };
        const locale = window.navigator.userLanguage || window.navigator.language;
        moment.locale(locale);
    }

    updateSize = () => {
        let height = window.innerHeight - 200;
        this.setState({...this.state, height: height + 'px'});
    }

    componentDidMount() {
        this.props.actionLoadColumns();
        this.updateSize();
        window.addEventListener('resize', this.updateSize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateSize);
    }

    getRowStyle = (state, rowInfo, column) => {
        const { users, selectedUsers } = this.props;
        let background = '#f5f5f5';
        const user = users[rowInfo.viewIndex];
        const selected = selectedUsers.includes(user.username);

        if (selected) {
            background = HIGHLIGHT_BACKGROUND_COLOR;
        } else if (rowInfo.viewIndex % 2 === 0) {
            background = 'inherit';
        }

        return {
            onClick: this.onRowClick.bind(this, rowInfo),
            onContextMenu: this.onRowRightClick.bind(this, rowInfo),
            style: {
                background: background
            }
        };
    }

    onRowClick = (rowInfo, e) => {
        const { selectedUsers: oldSelectedUsers, onUserSelect } = this.props;
        const { username } = rowInfo.original;

        let newSelectedUsers = [];

        if (e.ctrlKey || e.shiftKey) {
            newSelectedUsers = oldSelectedUsers.includes(username)
                ? oldSelectedUsers.filter((selectedUserName) => selectedUserName !== username)
                : [...oldSelectedUsers, username];
        }

        let data = username;

        if (newSelectedUsers.length > 1) {
            data = newSelectedUsers;
        }

        if (newSelectedUsers.length === 1 && e.ctrlKey) {
            data = newSelectedUsers[0];
        }

        onUserSelect(data);
    }

    onRowRightClick = (rowInfo) => {
        this.props.onUserSelect(rowInfo.original.username, false);
    }

    onResize = (newResized) => {
        let id = newResized[0].id;
        let value = newResized[0].value;
        if (id && value) {

            if (this.resizeTimer) {
                clearTimeout(this.resizeTimer);
            }

            this.resizeTimer = setTimeout(() => {
                this.props.actionSaveColumn(newResized);
            }, 250);

        }
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.columns = this.createColumns(nextProps)
    }

    handleSortingChange = (e) => {
        const { field } = e.currentTarget.dataset;
        const oppositeDirection = {
            [SORT_DIRECTION.asc]: SORT_DIRECTION.desc,
            [SORT_DIRECTION.desc]: SORT_DIRECTION.asc,
        };

        const { sortField, sortDirection } = this.state;
        const dir = field === sortField ? oppositeDirection[sortDirection] : sortDirection;
        this.setState((state) => ({
            ...state,
            sortField: field,
            sortDirection: dir
        }), this.getUsers);

        
    }

    getUsers = () => {
        this.props.actionLoadUsers(this.state.sortField, this.state.sortDirection);
    }

    renderHeaderColumn = (name, field) => {
        return (
            <div className="UsersTable__header__cell" data-field={field} onClick={this.handleSortingChange}>
                {I18n.t(name)}
            </div>
        );
    }

    createColumns(props) {
        return [
            {Header: this.renderHeaderColumn('Username', 'username'), accessor: 'username', minWidth: 100, width: props.table.columns.username},
            {Header: this.renderHeaderColumn('Created Date', 'createdDate'), accessor: 'createdDate', minWidth: 100, width: props.table.columns.createdDate},
            {Header: this.renderHeaderColumn('Created By', 'createdBy'), accessor: 'createdBy', minWidth: 100, width: props.table.columns.createdBy},
            {Header: this.renderHeaderColumn('Password Changed', 'passwordChangedDate'), accessor: 'passwordChangedDate', minWidth: 100, width: props.table.columns.passwordChangedDate},
            {Header: this.renderHeaderColumn('Locked Date', 'lockedDate'), accessor: 'lockedDate', minWidth: 100, width: props.table.columns.lockedDate},
        ];
    }

    get sortedColumn() {
        const columnIndex = this.columns.findIndex((x) => x.accessor === this.state.sortField);
    
        if (columnIndex >= 0) {
          return {
            direction: this.state.sortDirection || SORT_DIRECTION.asc,
            columnIndex: columnIndex,
          };
        }
    
        return {};
      }

    getTdProps(_, { original }, { id: cellId }) {
        return {
            title: original[cellId] || undefined
        };
    }

    render() {
        return (
            <Table
                className="UsersTable"
                serverSorting={false}
                config={{
                    data: this.props.users,
                    columns: this.columns,
                    getTrProps: this.getRowStyle,
                    onResizedChange: this.onResize,
                    getTdProps: this.getTdProps
                }}
                loadMetadata={{
                    sorting: this.sortedColumn
                }}
                onLoadData={this.getUsers}
            />
        )
    }
}

UsersTable.propTypes = {
    table: PropTypes.shape({
        rowsCount: PropTypes.number,
        columns: PropTypes.object,
    }),
    users: PropTypes.array,
    selectedUsers: PropTypes.array,
    actionLoadColumns: PropTypes.func,
    actionSaveColumn: PropTypes.func,
    actionLoadUsers: PropTypes.func,
    onUserSelect: PropTypes.func
};